import { CommentsProvider } from "@asksyntheia/comments";
import { ReactNode } from "react";
import { usersApi } from "../services/users";
import { useAppSelector } from "../store";

/** Gives the shared comment components this workspace's members and the signed-in user. */
export const WorkspaceCommentsProvider = ({ children }: { children?: ReactNode }) => {
  const { data: authorizedUsers = [] } = usersApi.useGetUsersQuery({ active: true });
  const user = useAppSelector((state) => state.global.user);

  return (
    <CommentsProvider members={authorizedUsers} user={user}>
      {children}
    </CommentsProvider>
  );
};
